import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'
import { createFileRoute } from '@tanstack/react-router'
import { findUser } from '@/api/users-api'
import { userKeys } from '@/hooks/users/query-keys'

export type TabOptions = 'details' | 'activities'

export type UserDetailsSearch = {
  tab: TabOptions
  action?: 'edit' | undefined
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/users/$userId'
)({
  validateSearch: (search: Record<string, string>): UserDetailsSearch => {
    const { tab, action } = search

    const validatedTab = ['details', 'activities'].includes(tab)
      ? (tab as TabOptions)
      : 'details'

    const validatedAction =
      validatedTab === 'details' && action === 'edit' ? 'edit' : undefined

    return {
      tab: validatedTab,
      action: validatedAction ?? undefined,
    }
  },
  beforeLoad() {
    requiredRoles([UserRole.ADMIN, UserRole.FACILITY_MANAGER])
  },
  loader: async ({ context: { queryClient }, params: { userId } }) =>
    queryClient.ensureQueryData({
      queryKey: userKeys.detail(userId),
      queryFn: () => findUser(userId),
    }),
})
